import { StoreId } from "../../decorators/StoreIdDecorator";
import API from "../API";

type BatchClassRoleViewModelData = {
  role: number;
  batchClassId: string;

  editBatchClassSettings?: boolean;
  modelMigration?: boolean;
  batchMigration?: boolean;
};

export default class BatchClassRoleViewModel {
  @StoreId
  role: number;
  batchClassId: string;

  editBatchClassSettings: boolean;
  modelMigration: boolean;
  batchMigration: boolean;

  static roleProperties: { key: string; label: string | null }[] = [
    { key: "editBatchClassSettings", label: "Edit Batch Class Settings" },
    { key: "modelMigration", label: "Template Migration" },
    { key: "batchMigration", label: "Batch Migration" },
  ];

  constructor(data: BatchClassRoleViewModelData) {
    this.role = data.role;
    this.batchClassId = data.batchClassId;

    this.editBatchClassSettings = data.editBatchClassSettings ?? false;
    this.modelMigration = data.modelMigration ?? false;
    this.batchMigration = data.batchMigration ?? false;
  }

  changeRolePropertyValue(propertyName: string, value: any) {
    //@ts-expect-error
    this[propertyName] = value;
  }

  getRolePropertyValue(propertyName: string): any {
    //@ts-expect-error
    return this[propertyName];
  }
  getSaveModel(): SaveBatchClassRoleViewModel {
    return new SaveBatchClassRoleViewModel(this);
  }

  static createTest(
    rest: Partial<BatchClassRoleViewModelData> = {},
  ): BatchClassRoleViewModel {
    const data: BatchClassRoleViewModelData = {
      batchClassId: "",
      role: 0,
      batchMigration: false,
      editBatchClassSettings: false,
      modelMigration: false,
    };

    return new BatchClassRoleViewModel({
      ...data,
      ...rest,
    });
  }
}
class SaveBatchClassRoleViewModel {
  role: number;
  batchClassId: string;

  editBatchClassSettings: boolean;
  modelMigration: boolean;
  batchMigration: boolean;
  constructor(data: BatchClassRoleViewModel) {
    this.role = data.role;
    this.batchClassId = data.batchClassId;
    this.editBatchClassSettings = data.editBatchClassSettings;
    this.modelMigration = data.modelMigration;
    this.batchMigration = data.batchMigration;
  }

  async save(): Promise<boolean> {
    return await API.post(`/v0/role/${this.batchClassId}`, null, this)
      .then((value: Response) => value.text())
      .then((value: string) => value === "true")
      .catch(() => {
        return false;
      });
  }
}
export { BatchClassRoleViewModelData, SaveBatchClassRoleViewModel };
